import { BaseApiService } from "../base/base-api.service";
import { AvailableLanguageDTO, AvailableLanguageSTO } from "../../models/available-language";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { ProviderSitesApiService } from "../provider-sites/provider-sites-api.service";
import { PropsFilter } from "src/models/api/props-filter";
export class AvailableLanguagesApiService extends BaseApiService<AvailableLanguageDTO, AvailableLanguageSTO> {
  constructor() {
    super({
      servicePath: "/AvailableLanguages",
      loadItemsPath: "/GetAvailableLanguages",
      saveItemsPath: "/SaveAvailableLanguages",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

// Loads available at current provider languages => SHOULD BE DEPRECATES, ALLOWED LANGUGAESARE LOAD
export const loadAllowedLanguages = async (signal: AbortSignal | undefined = undefined) => {
  const service = new ProviderSitesApiService();
  service.useLoadItemsPath("/GetAllowedLanguages");
  service.withNoAuth();

  const response = await service.loadItems(
    {} as PropsFilter,
    undefined,
    undefined,
    {
      pageNumber: 0,
      pageSize: 100,
    },
    false,
    60,
    signal
  );

  return response as any;
};
